import { Address, Agency, AgencySubtypeId, AgencyTypeId, Country, User } from '@app/models';
import { getAgencySubTypes, isPassengerApplicantAgency, resolveAgencyType } from '@app/util';
import * as R from 'ramda';

type GetUserId = (user: User) => number;
export const getUserId: GetUserId = R.prop('id');

type GetAgency = (user: User) => Agency;
export const getAgency: GetAgency = R.prop('agency');

type GetAgencyId = (user: User) => number;
export const getAgencyId: GetAgencyId = R.compose(R.prop('id'), getAgency);

type GetAgencyTypeId = (user: User) => AgencyTypeId;
export const getAgencyTypeId: GetAgencyTypeId = R.compose(resolveAgencyType, getAgency);

type GetAgencySubTypes = (user: User) => AgencySubtypeId[];
export const getAgencySubTypesForUser: GetAgencySubTypes = R.compose(getAgencySubTypes, getAgency);

type GetCountryOfUserAgency = (user: User) => Country;
export const getCountryOfUserAgency: GetCountryOfUserAgency = R.path(['agency', 'country']);

type GetUserType = (user: User) => boolean;
export const isApplicantUser: GetUserType = R.compose(R.prop('applicant'), getAgency);
export const isPassengerApplicantUser: GetUserType = R.compose(isPassengerApplicantAgency, getAgency);
export const isImUser: GetUserType = R.compose(R.prop('im'), getAgency);
export const isCossUser: GetUserType = R.compose(R.prop('coss'), getAgency);
export const isRu: GetUserType = R.compose(R.prop('ru'), getAgency);

export const isIntegrationPlatformUser: GetUserType = R.prop('integrationPlatformUser');
export const isAdmin: GetUserType = R.prop('admin');
export const isRneJo: GetUserType = R.prop('rneJo');
export const isReadonlyUser: GetUserType = R.prop('readonly');

type GetUserString = (user: User) => string;
export const getUsername: GetUserString = R.prop('username');
export const getFirstName: GetUserString = R.prop('firstName');
export const getName: GetUserString = R.prop('name');
export const getFullName = (user: User) => R.join(' ', [getName(user), getFirstName(user)]);
export const getAgencyName: GetUserString = R.compose(R.prop('name'), getAgency);
export const getUserType: GetUserString = R.path(['userType', 'description']);

type GetAddress = (user: User) => Address;
export const getAddress: GetAddress = R.prop('address');

type GetAddressString = (address: Address) => string;
type GetAddressNumber = (address: Address) => number;
type GetAddressCountry = (address: Address) => Country;
export const getAddressId: GetAddressNumber = R.prop('id');
export const getAddressPhone: GetAddressString = R.prop('phone');
export const getAddressFax: GetAddressString = R.prop('fax');
export const getAddressStreet: GetAddressString = R.prop('street');
export const getAddressStreet2: GetAddressString = R.prop('street2');
export const getAddressPoBox: GetAddressString = R.prop('poBox');
export const getAddressZip: GetAddressString = R.prop('zip');
export const getAddressCity: GetAddressString = R.prop('city');
export const getAddressCountry: GetAddressCountry = R.prop('country');
export const getAddressEmail: GetAddressString = R.prop('email');

type GetUserDate = (user: User) => number[];
export const getGdprAcceptedDate: GetUserDate = R.prop('rneGdprAcceptedDate');
